<template>
	<v-dialog :fullscreen="isMobile" scrollable attach name="contactform" ref="contactform" v-model="contactForm" transition="dialog-top-transition" max-width="700px">
		<v-card raised>
			<v-card-title class="display-1 modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="contactForm = false">
					<v-icon large>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<h4 class="mb-1">
					If you would like to change any details about your event or location, please contact us.
				</h4>
				<p class="mb-3" style="font-size: 0.9em; color: #AAA">
					If this is urgent feel free to call us at (209) 975-7789
				</p>
				<v-form v-model="valid">
					<v-text-field
						color="link"
						v-model="name"
						label="Name"
						:counter="20"
						:rules="nameRules"
						required
						v-if="!userIsAuthenticated"
					></v-text-field>
					<v-text-field
						color="link"
						v-model="email"
						label="E-mail"
						:rules="emailRules"
						required
						v-if="!userIsAuthenticated"
					></v-text-field>
					<v-text-field
						color="link"
						v-model="phone"
						label="Phone Number"
						:rules="phoneRules"
					></v-text-field>
					<v-text-field
						color="link"
						v-model="city"
						label="City &amp; State"
						:rules="cityRules"
					></v-text-field>
					<v-textarea
						color="link"
						v-model="message"
						label="Message"
						:rules="messageRules"
						rows="5"
						required
					></v-textarea>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn class="btn-blue white--text" :loading="submitting" :disabled="!valid" @click="sendContactEmail">Send Message</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'contactForm',
	data() {
		return {
			submitting: false,
			valid: false,
			name: '',
			email: '',
			phone: '',
			city: '',
			message: '',
			nameRules: [
				v => !!v || 'Name is required',
				v => v.length <= 20 || 'Name must be less than 20 characters'
			],
			emailRules: [
				v => !!v || 'E-mail is required',
				v =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
					'E-mail must be valid'
			],
			phoneRules: [
				v =>
					/(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
					'Please enter a valid phone number'
			],
			cityRules: [
				v => v.length <= 20 || 'City must be less than 20 characters',
				v => v.length > 0 || 'Please enter a city'
			],
			messageRules: [v => v.length > 0 || 'Please enter a message']
		}
	},
	created() {
		this.name = this.user.first_name + ' ' + this.user.last_name
		this.email = this.user.email
	},
	methods: {
		...mapActions(['setSnackbarOpen', 'setSnackbarText', 'setModalOpen']),
		sendContactEmail() {
			this.submitting = true
			axios
				.post('/api/v1/contact/', {
					name: this.name,
					message: this.message,
					email: this.email,
					phone: this.phone,
					city: this.city,
					event: this.getEditEventContactFormEvent.pk
				})
				.then(response => {
					this.contactForm = false
					this.setSnackbarOpen(true)
					this.setSnackbarText('Message Sent!')
				})
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getEditEventContactFormEvent',
			'getModalProp',
			'userIsAuthenticated'
		]),
		contactForm: {
			get() {
				return this.getModalProp('editEventContactForm')
			},
			set(val) {
				this.setModalOpen({ prop: 'editEventContactForm', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
